import React from "react";
import { Box } from "grommet";
import QuestionForm from "./QuestionForm";
import { useSelector } from "react-redux";

const DetailsPanel = ({ updateActiveIndex, addOnsBool }) => {
  const bookingDetails = useSelector((state) => state.payment.bookingDetails);

  return (
    <Box direction="column">
      <Box pad={{ bottom: "10px" }} fill>
        <QuestionForm
          bookingDetailsPerson={bookingDetails}
          updateActiveIndex={updateActiveIndex}
          addOnsBool={addOnsBool}
        />
      </Box>
    </Box>
  );
};

export default DetailsPanel;
